import {IFriendJson, IFriendStatus} from "../../../../nodeserver/structs/database";
import {ServerApi} from "../api.js";
import {handleFetchError, showNotice} from "../helpers/functions.js";
import JSX, {JSXElement} from "../helpers/react.js";


const Links = {
    AbstractLink(props: {href: string, className?: string}, content: string){
        return (
            <a href={props.href} target="_blank" className={"bordered href-icon materiable"+(props.className?' '+props.className:'')}>{content}</a>
        )
    },
    ShikimoriElement(props: {nickName: string}){
        return (
            <Links.AbstractLink href={`//shikimori.one/${escapeHtml(props.nickName)}`} className="shiki-icon">
                <img src="/img/icon/shikimori-icon.svg" alt="Shikimori"/>
            </Links.AbstractLink>

        )
    },
    TelegramElement: class extends JSXElement<{nickName: string}>{
        render() {
            return (
                <Links.AbstractLink href={`//${escapeHtml(this.props.nickName)}.t.me`}>
                    <img src="/img/icon/tg-icon.svg" alt="" width={40} height={40}/>
                </Links.AbstractLink>
            );
        }
    },
    VkElement(props: { id: number }){
        return (
            <Links.AbstractLink href={`//vk.com/id${props.id}`}>
                <img src="/img/icon/VK-icon.svg" alt="" width={40} height={40}/>
            </Links.AbstractLink>
        )

    }
}

function AbstractButton(props: {className: string; faClass: string; balloon: string; href?: string}) {
    function Btn(props: any, content: string){
        if(!props.href) delete props.href;
        return JSX.createElement(props.href?'a':'div', props, content)
    }
    return (
        <Btn className={"main-button bordered-overflow "+props.className}
             data-balloon-pos="left"
             data-balloon={props.balloon}
             href={props.href}>
            <i className={"fa "+props.faClass} />
        </Btn>
    );
}
function Buttons({list, id}: {list: IFriendStatus, id: number}){
    const buttons = [
        <AbstractButton className="transparent send-message-btn" faClass="fa-comment" balloon="Написать сообщение" href={`/users/messages/#messages${id}`} />,
    ];
    switch(list){
        case 'friends':
        case 'following':
        case 'sent-requests':
            const text = {'friends': 'Удалить', 'following': 'Отписаться', 'sent-requests': 'Отменить заявку'}[list];
            buttons.push(
                <AbstractButton className="remove attention " faClass="fa-trash" balloon={text} />
            )
            break;
        case 'requests':
            buttons.push(
                <AbstractButton className="add" faClass="fa-check" balloon="Добавить в друзья" />,
                <AbstractButton className="remove neutral" faClass="fa-times" balloon="Оставить в подписчиках" />
            )
            break;
        case 'followers':
            buttons.push(
                <AbstractButton className="add" faClass="fa-check" balloon="Добавить в друзья" />
            )
            break;

    }
    return (
        <div className={`action-btns-profile ${list}`}>
            {...buttons}
        </div>
    );
}
function LinkHtml(props: {friend: IFriendJson}){
    return <a href={`/users/id${props.friend.id}`}>{props.friend.nickname}</a>;
}
class FriendElement{
    private $element!: JQuery<HTMLElement>;

    constructor(private readonly friend: IFriendJson) {}

    public buildHtml(){

        const ans = (
            <li className="user-profile">
                <div className="profile-img">
                    <a href={`/users/id${this.friend.id}`}>
                        <img src={this.friend.avatars.big} style={`--small: url(${this.friend.avatars.small})`} className="bordered" alt="Avatar" />
                    </a>
                </div>
                <div className="profile-content">
                    <div className="top-data">
                        <a href={`/users/id${this.friend.id}`} className={`nickname label${this.friend.roles.includes('admin') || this.friend.roles.includes('root')?' admin':''}`}>{this.friend.nickname}</a>
                        {this.friend.last_online> (+new Date/1000) - 60*5 && <> <i className="online fa-circle fa" /></>}
                    </div>
                    <div className="bottom-data">
                        {['',<div>Пол: <gray>Мужской</gray></div>,<div>Пол: <gray>Женский</gray></div>][this.friend.sex]}
                        {!!this.friend.banned && <div style="color: var(--main-red)">Заблокирован!</div>}
                        <div className="remote-ids">
                            {!!this.friend.ids.tg_nickname && <Links.TelegramElement nickName={this.friend.ids.tg_nickname} />}
                            {!!this.friend.ids.vk && !is_ukraine && <Links.VkElement id={this.friend.ids.vk}/>}
                            {!!this.friend.ids.shikimori?.nickname && <Links.ShikimoriElement nickName={this.friend.ids.shikimori.nickname}/>}
                        </div>
                    </div>
                </div>
                {user_id == page_id && <Buttons list={this.friend.list} id={this.friend.id}/>}
            </li>
        );
        return this.$element = $(ans).data('friend', this);
    }
    public async delete(){
        if(this.$element.hasClass('blocked')) return;
        this.$element.addClass('blocked')
        try{
            await ServerApi.users.friends.delete(this.friend.id);
            switch (this.friend.list){
                case 'friends':
                    showNotice(<><LinkHtml friend={this.friend} /> удалён из друзей.</>, 'Прощай', 'error', true);
                    FriendsLoader.getLoader(page_id!)?.dropList('followers');
                    FriendElement.totalCountDesc('friends');
                    FriendElement.totalCountInc('followers');
                    break;
                case 'requests':
                    showNotice(<>Заявка в друзья от <LinkHtml friend={this.friend} /> отклонена.</>, 'Ты мне не друг!', 'error', true);
                    FriendsLoader.getLoader(page_id!)?.dropList('followers');
                    this.$element.fadeOut().promise().done(()=>this.$element.remove());
                    break;
                case 'following':
                    showNotice(<>Отписался от пользователя <LinkHtml friend={this.friend} />.</>, 'Долой с глаз моих!', 'error', true);
                    break;
                case 'followers':
                    console.warn('... This shouldn\'t happened.... How can i remove friend from followers...?');
                    break;
                case 'sent-requests':
                    showNotice(<>Отозвал заявку в друзья пользователю <LinkHtml friend={this.friend} />.</>, 'Удалено', 'error', true);
                    break;
            }
            this.$element
                .addClass('deleted')
                .find('.remove')
                [0].replaceWith(<AbstractButton className="attention add" faClass="fa-undo" balloon="Отмена" />)
                // .prop(
                //     'outerHTML',


        }
        catch (e){
            handleFetchError(e);
        }
        finally {
            this.$element.removeClass('blocked')
        }
    }
    public async add(){
        if(this.$element.hasClass('blocked')) return;
        this.$element.addClass('blocked')
        try{
            await ServerApi.users.friends.add(this.friend.id);
            switch (this.friend.list){
                case 'friends':
                    showNotice(`Пользователь ${this.friend.nickname} опять в друзьях.`, 'Усп... назад!', 'success');
                    FriendsLoader.getLoader(page_id!)?.dropList('followers');
                    FriendElement.totalCountInc('friends');
                    FriendElement.totalCountDesc('followers');
                    break;
                case 'requests':
                    showNotice(`Заявка в друзья от пользователя ${this.friend.nickname} принята.`, 'У Вас новый друг!', 'success');
                    FriendsLoader.getLoader(page_id!)?.dropList('friends');
                    this.$element.fadeOut().promise().done(()=>this.$element.remove());
                    FriendElement.totalCountInc('friends');
                    FriendElement.totalCountDesc('followers');
                    break;
                case 'following':
                    break;
                    // showNotice(`Отписался от пользователя ${this.friend.nickname}.`, 'Долой с глаз моих!', 'error');
                    // break;
                case 'followers':
                    showNotice(`Заявка в друзья от пользователя ${this.friend.nickname} принята.`, 'У Вас новый друг!', 'success');
                    FriendsLoader.getLoader(page_id!)?.dropList('friends');
                    this.$element.fadeOut().promise().done(()=>this.$element.remove());
                    break;
                case 'sent-requests':
                    // showNotice(`Отозвал заявку в друзья пользователю ${this.friend.nickname}.`, 'Удалено', 'error');
                    break;
            }

            this.$element.removeClass('deleted').find('.action-btns-profile')
                [0].replaceWith( <Buttons list={this.friend.list} id={this.friend.id} />);
        }catch (e){
            handleFetchError(e);
        }finally {
            this.$element.removeClass('blocked');
        }
    }


    private static totalCountDesc(listId: IFriendStatus){
        const $el = $(`.li-friends[data-listid=${listId}] .count`),
            $totalCountEl = $(".total-friends-count");
        $el.text(+($el.text()||1)-1);
        $totalCountEl.text(+($totalCountEl.text()||1)-1);

    }
    private static totalCountInc(listId: IFriendStatus){
        const $el = $(`.li-friends[data-listid=${listId}] .count`),
            $totalCountEl = $(".total-friends-count");
        $el.text(+($el.text()||0)+1);
        $totalCountEl.text(+($totalCountEl.text()||0)+1);
    }

}
class FriendsLoader{
    private lists: Map<IFriendStatus, FriendElement[]> = new Map();
    private loaded: Boolean = false;
    private constructor(private readonly userId: number) {}
    private static Instances: Map<number, FriendsLoader> = new Map();
    static getLoader(userId: number): FriendsLoader{
        return this.Instances.get(userId) ?? this.Instances.set(userId, new FriendsLoader(userId)).get(userId)!;
    }
    public async loadList(listId: IFriendStatus, $contentElement: JQuery){
        if(this.lists.has(listId)) return;
        try{
            const $appendTo = $contentElement.find('.items')
                .html('<div style="text-align: center; padding: 20px 15px"><i class="loading large"></i></div>');

            const data = await ServerApi.users.friends.getFriendsList(this.userId, listId);
            this.lists.set(listId, data.map(it=>new FriendElement(it)));
            $appendTo.html(data.length?'':'<div style="text-align: center; padding: 20px 15px">По заданным фильтрам нет результатов</div>');
            for(let friend of this.lists.get(listId)!) {
                const $element = friend.buildHtml()
                    .appendTo($appendTo)
            }
            this.loaded = true;
        }
        catch (e){
            handleFetchError(e);
        }

    }
    public dropList(listId: IFriendStatus){
        this.lists.delete(listId);
    }
}

$('html')
    .on('click', '.li-show-friends', async function(){
        const $activeTab = $('.li-friends.active');
        const selectedListId = $activeTab.data('listid');
        await FriendsLoader.getLoader(page_id!).loadList(selectedListId, $($activeTab.data('id')));
    })
    .on('click', '.li-friends',async function (){
            const $content = $($(this).data('id'));
            await FriendsLoader.getLoader(page_id!)
                .loadList($(this).data('listid')!, $content);
    })
    .on('click', '.user-profile .remove',async function(){
        await ($(this).parents('.user-profile').data('friend') as FriendElement).delete();
    })
    .on('click', '.user-profile .add',async function(){
        await ($(this).parents('.user-profile').data('friend') as FriendElement).add();

    })
    .on('click', '.friends-btn.add', async function(){
        //TODO
        if($(this).hasClass('blocked')) return;
        $(this).addClass('blocked')
        try{
            await ServerApi.users.friends.add(page_id!);
            await updateFriendStatus();
            showNotice('Добавил пользователя в друзья', 'Успех', 'success');
        }
        catch (e){ handleFetchError(e);}
        finally {
            $(this).removeClass('blocked');
        }
    })
    .on('click', '.friends-btn.remove', async function(){
        if($(this).hasClass('blocked')) return;
        $(this).addClass('blocked')
        try{
            await ServerApi.users.friends.delete(page_id! as number);
            showNotice('Удалил пользователя из друзей','Успех',  'error');
            await updateFriendStatus();
        }
        catch (e){ handleFetchError(e);}
        finally {
            $(this).removeClass('blocked');
        }
    })
    .on('click', '.notification .removefriend', async function(){
        if($(this).hasClass('blocked')) return;
        $(this).addClass('blocked')
        try{
            await ServerApi.users.friends.delete($(this).data('id')! as number);
            showNotice('Отклонил заявку','Успех','error');
            const notif = $(this).parents('.notification');
            notif.fadeOut().promise().done(()=>notif.remove());
            await ServerApi.profile.notifications.removeById(notif.data('id')! as number);
        }
        catch (e){ handleFetchError(e);}
        finally {
            $(this).removeClass('blocked');
        }
    })
    .on('click', '.notification .addfriend', async function(){
        if($(this).hasClass('blocked')) return;
        $(this).addClass('blocked')
        try{
            await ServerApi.users.friends.add($(this).data('id')! as number);
            showNotice('Добавил пользователя в друзья','Успех','success');
            const notif = $(this).parents('.notification');
            notif.fadeOut().promise().done(()=>notif.remove());
            await ServerApi.profile.notifications.removeById(notif.data('id')! as number);
        }
        catch (e){ handleFetchError(e);}
        finally {
            $(this).removeClass('blocked');
        }

    })

$(updateFriendStatus);

async function updateFriendStatus(){
    try {
        const $btn = $(".friends-btn");
        if ($btn[0]) {
            const isFriend = await ServerApi.users.friends.isFriend(page_id! as number);
            if (isFriend === null || isFriend === 'requests' || isFriend === 'followers')
                $btn.text('Добавить в друзья').addClass('add').removeClass('remove');
            else if (isFriend === 'sent-requests')
                $btn.text('Отменить заявку в друзья').addClass('remove').removeClass('add');
            else if (isFriend === 'friends')
                $btn.text('Удалить из друзей').addClass('remove').removeClass('add');
            else if (isFriend === 'following')
                $btn.text('Отписаться').addClass('remove').removeClass('add');
        }
    }catch (e){
        handleFetchError(e);
    }
}